import { render, staticRenderFns } from "./confrim.vue?vue&type=template&id=3c12f86d&scoped=true&"
import script from "./confrim.vue?vue&type=script&lang=js&"
export * from "./confrim.vue?vue&type=script&lang=js&"
import style0 from "./confrim.vue?vue&type=style&index=0&id=3c12f86d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c12f86d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c12f86d')) {
      api.createRecord('3c12f86d', component.options)
    } else {
      api.reload('3c12f86d', component.options)
    }
    module.hot.accept("./confrim.vue?vue&type=template&id=3c12f86d&scoped=true&", function () {
      api.rerender('3c12f86d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/advocacy/confrim.vue"
export default component.exports